"use client"

import dynamic from "next/dynamic";

// `next/dynamic` with `ssr: false` cannot be called from a Server Component
// (app/[locale]/layout.tsx) directly, so the lazy wrapper lives in its own
// client module. FCM registration is never on the critical path — see
// FcmInitializer.tsx.
const FcmInitializer = dynamic(() => import("@/app/components/utils/FcmInitializer"), {
    ssr: false,
});

export default FcmInitializer;
